import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LINK_FILTER, } from '@as-react/common-types';
import { XIcon } from '@yonderland/andes-icons';
import { Box, ConditionalWrapper, IconButton, Link, Scrollable, SearchFieldAlpha, Stack, } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { FilterLink } from '../../../lister/filters/FilterLink';
import { FiltersSizes } from './FiltersSizes';
const DEFAULT_COLLAPSED_ITEMS_COUNT = 8;
const MAX_VIEW_MORE_ITEMS = 20;
const SCROLLABLE_LIST_HEIGHT = 276;
export const FiltersSelectList = ({ desktop, filter, onFilterItemChange, type, toggleFilterOptions = true, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [showAll, setShowAll] = useState(false);
    const [search, setSearch] = useState('');
    const toggleFilterValue = (e, filterValueObject) => {
        if (type === LINK_FILTER) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
        }
        onFilterItemChange({
            filterOn: filter.filterOn,
            filterOnName: filter.name,
            filteredItems: [
                {
                    filterKey: filterValueObject.filterKey,
                    filterKeyName: filterValueObject.name,
                    filterOn: filter.filterOn,
                    filterOnName: filter.name,
                    filterType: type,
                },
            ],
            filterType: type,
            filterDisplayHint: filter.displayHint,
            filterContentType: filter.filterContentType,
            queryParamKey: filter.queryParamKey,
        });
    };
    const handleSearchChange = (value) => setSearch(value);
    const handleSearchReset = () => setSearch('');
    const filtersSize = filter.values.length;
    const itemsToShow = filter.itemsToShow
        ? filter.itemsToShow
        : filtersSize <= MAX_VIEW_MORE_ITEMS
            ? DEFAULT_COLLAPSED_ITEMS_COUNT
            : Infinity;
    const hasTooManyItems = filtersSize > itemsToShow && filtersSize <= MAX_VIEW_MORE_ITEMS;
    const isSearchEnabled = filter.filterOn === 'brand' &&
        filter.visibleSearchBox === 'yes' &&
        ((desktop && filtersSize > (filter.itemsToShow ? filter.itemsToShow : DEFAULT_COLLAPSED_ITEMS_COUNT)) || !desktop);
    const searchFieldId = `${filter.name}_search`;
    const items = (() => {
        if (search) {
            const searchTerm = search.toLowerCase();
            if (searchTerm.length === 1) {
                return filter.values.filter(({ name }) => name.toLowerCase().startsWith(searchTerm));
            }
            else {
                return filter.values.filter(({ name }) => name.toLowerCase().includes(searchTerm));
            }
        }
        return !toggleFilterOptions || showAll ? filter.values : filter.values.slice(0, itemsToShow);
    })();
    const handleClickShowAll = () => setShowAll(prevShowAll => !prevShowAll);
    return (_jsxs(_Fragment, { children: [!desktop && type === LINK_FILTER ? (_jsx(FilterLink, { items: items, toggleFilterValue: toggleFilterValue })) : (_jsxs(Stack, { direction: "col", gap: "4", children: [isSearchEnabled && (_jsx(SearchFieldAlpha, { onChange: handleSearchChange, autoSearch: true, input: {
                            id: searchFieldId,
                            name: searchFieldId,
                            value: search,
                            placeholder: t('product.lister.filter.brand.search'),
                            autoComplete: 'off',
                            adornmentEnd: search ? (_jsx(IconButton, { onClick: handleSearchReset, size: "sm", variant: "plain", icon: { source: XIcon }, testId: `${searchFieldId}_reset`, type: "reset" })) : null,
                        } })), Boolean(items.length) && (_jsx(ConditionalWrapper, { condition: !desktop && isSearchEnabled, wrapper: children => (_jsx(Scrollable, { gradient: true, horizontal: false, children: children })), children: _jsx(ConditionalWrapper, { condition: Boolean(desktop) && items.length > MAX_VIEW_MORE_ITEMS, wrapper: children => (_jsx(Scrollable, { gradient: true, horizontal: false, height: SCROLLABLE_LIST_HEIGHT, children: children })), children: _jsx(Stack, { direction: "col", gap: "4", children: _jsx(FiltersSizes, { items: items, type: type, filter: filter, toggleFilterValue: toggleFilterValue, desktop: desktop, search: search }) }) }) }))] })), toggleFilterOptions && hasTooManyItems && !search && (_jsx(Box, { paddingBlockStart: "4", paddingBlockEnd: "2", children: _jsx(Link, { theme: "neutral", variant: "secondary", onClick: handleClickShowAll, children: showAll ? t('product.lister.show.less') : t('product.lister.show.more') }) }))] }));
};
